import type { CardsFeatureConfig } from '@shared/cards-config';
import type { DeepPartial } from '@luna/utils-ts';

import {
    CardBankHeaderFeatureConfig,
    CardLimitsChangeFeatureConfig,
    CardLockFeatureConfig,
    CardLoyaltyProgramExternalFeatureConfig,
    CardsSettingsCardDetailsFeatureConfig,
    CreditCardContentBoxFeatureConfig,
    CreditSharedFeatureConfig,
    DebitCardContentBoxFeatureConfig,
    InstallmentsFeatureConfig,
} from './featureConfig';

export const cards: DeepPartial<CardsFeatureConfig> = {
    isNativeAliasChangeAllowed: true,
    bank: {
        showAsProduct: false,
        settings: {
            limitChange: false,
        },
    },
    credit: CreditSharedFeatureConfig.HR,
    statements: {
        signed: true,
        showPhoneNumbersDropdown: false,
        reversibleToPaperDelivery: false,
    },
    components: {
        limitsChange: CardLimitsChangeFeatureConfig.HR,
        cardLock: CardLockFeatureConfig.HR,
        cardLoyaltyProgramExternal: CardLoyaltyProgramExternalFeatureConfig.HR,
        bankCardHeader: CardBankHeaderFeatureConfig.HR,
        installments: InstallmentsFeatureConfig.HR,
        settings: {
            cardDetails: CardsSettingsCardDetailsFeatureConfig.HR,
        },
        creditCardContentBox: CreditCardContentBoxFeatureConfig.HR,
        debitCardContentBox: DebitCardContentBoxFeatureConfig.HR,
    },
    overview: {
        VIRTUAL_CREDIT: {
            MAIN: {
                hide: false,
            },
            AUTHORIZED: {
                hide: false,
            },
            AUTHORIZED_STANDALONE: {
                hide: false,
            },
        },
    },
};
